import { WorkItemTypes, WorkItemTypeValue } from 'common/workitems/constants/workitem-types';

export class WorkItemHelper {
  public static convertItemTypeToDbEnum(itemType: WorkItemTypes): number {
    switch (itemType) {
      case WorkItemTypes.CHAT:
        return WorkItemTypeValue.CHAT;
      case WorkItemTypes.EMAIL:
        return WorkItemTypeValue.EMAIL;
      case WorkItemTypes.SMS:
        return WorkItemTypeValue.SMS;
      case WorkItemTypes.FACEBOOK:
        return WorkItemTypeValue.FACEBOOK;
      case WorkItemTypes.ASYNC_MESSAGE:
        return WorkItemTypeValue.ASYNC_MESSAGE;
      default:
        throw new Error(`Trying to convert an unknown item type: (${itemType})`);
    }
  }

  public static convertDbEnumToItemType(dbEnum: WorkItemTypeValue): string {
    switch (dbEnum) {
      case WorkItemTypeValue.CHAT:
        return WorkItemTypes.CHAT;
      case WorkItemTypeValue.EMAIL:
        return WorkItemTypes.EMAIL;
      case WorkItemTypeValue.SMS:
        return WorkItemTypes.SMS;
      case WorkItemTypeValue.LENS:
        return WorkItemTypes.LENS;
      case WorkItemTypeValue.FACEBOOK:
        return WorkItemTypes.FACEBOOK;
      case WorkItemTypeValue.ASYNC_MESSAGE:
        return WorkItemTypes.ASYNC_MESSAGE;
      default:
        throw new Error(`Unknown Bold WorkItem ItemType [${dbEnum}]`);
    }
  }
}
